import React from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Segment } from 'semantic-ui-react';
import { withAuthenticator } from 'aws-amplify-react';
import HeaderSmall from './HeaderSmall';
import FooterBlock from './FooterBlock';
import Subscribers from './Subscribers';

const Admin = props => (
  <div>
    <Helmet defer={false}>
      <title>TribeVibe - Admin</title>
    </Helmet>
    <HeaderSmall />
    <Segment style={{ padding: '8em 0em' }} vertical>
      <Grid container stackable verticalAlign="middle">
        <Grid.Row>
          <Grid.Column width={8}>
            <Subscribers match={props.match} history={props.history} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
    <FooterBlock />
  </div>
);

export default withAuthenticator(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin.js